import React, { useEffect, useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import {
  Button,
  Divider,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import SimpleModalCompact from "../../common/ModalCompact/SimpleModalCompact";
import InvitingCompanySelector from "../HelpUserModal/InvitingCompanySelector";

const SUBSCRIPTION_LEVELS = [
  "Free",
  "Mini",
  "Standard",
  "Pro",
  "Business",
  "Premium"
];

const PaymentLiabilityModal = ({ user, onClose, onSave }) => {
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [subscriptionLevel, setSubscriptionLevel] = useState(0);

  const siteRoles = useSelector(
    state => state.api.siteUsers.siteRoles
  );

  /**
   * Match user.siteRoleId → siteRoles.siteRoleId
   * and extract required subscription level
   */
  const requiredRole = useMemo(() => {
    
    if (!user || !siteRoles) return null;
    return siteRoles.find(role => role.siteRoleId === user.siteRoleId);
  }, [user, siteRoles]);

  const requiredSubscriptionLevel =
    requiredRole?.subscriptionLevel ?? 0;

  /**
   * Sync subscription level when user/role changes
   */
  useEffect(() => {
    setSubscriptionLevel(requiredSubscriptionLevel);
  }, [requiredSubscriptionLevel]);

  return (
    <SimpleModalCompact
      title="Hantera betalningsansvar"
      open={!!user}
      onClose={onClose}
      fullScreen={false}
      footer={
        <>
          <Button onClick={onClose}>
            <FormattedMessage id="btn.cancel" />
          </Button>

          <Button
            variant="contained"
            disabled={!user}
            onClick={() =>
              onSave(user, editingCompanyId, subscriptionLevel)
            }
          >
            Ta betalningsansvar
          </Button>
        </>
      }
    >
      {user && (
        <>
          <InvitingCompanySelector
            onChange={id => setEditingCompanyId(id)}
          />
          <Box sx={{ maxWidth: 450 }}>
            <p>
              Användaren <strong>{user.email}</strong> har för låg
              prenumerationsnivå för att använda den tilldelade rollen.
            </p>
            <p>
              Du kan ta betalningsansvar för användaren med den
              prenumerationsnivå som rollen kräver.
            </p>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel id="subscription-level-label">
                Prenumerationsnivå
              </InputLabel>

              <Select
                labelId="subscription-level-label"
                label="Prenumerationsnivå"
                value={subscriptionLevel}
                onChange={e =>
                  setSubscriptionLevel(Number(e.target.value))
                }
              >
                {SUBSCRIPTION_LEVELS.map((label, value) => (
                  <MenuItem
                    key={value}
                    value={value}
                    disabled={value < requiredSubscriptionLevel}
                  >
                    {label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </>
      )}
    </SimpleModalCompact>
  );
};

export default PaymentLiabilityModal;
